import React, { Component } from "react";
import PropTypes from "prop-types";
//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const CompareContext = React.createContext();

class CompareProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemsToCompare: [],
        };
    }
    static propTypes = {
        itemsToCompare: PropTypes.array,
        children: PropTypes.any
      };

    componentDidMount() {
        this.loadItems();
    }

    loadItems() {
        const storedItems = localStorage.getItem("itemsCompared");
        if (storedItems) {
            this.setState({ itemsToCompare: JSON.parse(atob(storedItems)) });
        }
    }

    saveItems () {
        const { itemsToCompare } = this.state;
        localStorage.setItem("itemsCompared", btoa(JSON.stringify(itemsToCompare)));
    }

    setItemCompare = (articulo,notifyProp, callback) => {
        this.setState(prevState => {
            // console.log(notifyProp)
            const exists = prevState.itemsToCompare.some(item => item.code === articulo.code);
            if (!exists && prevState.itemsToCompare.length < 4) {
                if(notifyProp==null){
                    toast.warn("Articulo añadido a comparación!", {
                        autoClose: 1600
                    });
                }
                const newItemsToCompare = [...prevState.itemsToCompare, articulo];
                return { itemsToCompare: newItemsToCompare };
            } else {
                if (exists) {
                    if(notifyProp==null){
                        toast.warn("El item ya existe en la lista!", {
                            autoClose: 1600
                       });
                    }
                } else {
                    if(notifyProp==null){
                        toast.warn("Limite de articulos en la comparación alcanzado!", {
                            autoClose: 1600
                       });
                    }
                }
            }
            return null;
        }, () => {
            this.saveItems();
            if (callback) callback();
        });
    }

    removeItem(articulo, callback) {
        this.setState(prevState => {
            const newItems = prevState.itemsToCompare.filter(item => item.code !== articulo.code);
            return { itemsToCompare: newItems };
        }, () => {
            this.saveItems();
            if (callback) callback();
        });
    }

    clearCompareItems = () => {
        localStorage.removeItem("itemsCompared");
        this.setState({ itemsToCompare: [] });
    }

    render() {
        const { itemsToCompare } = this.state;
        const { children } = this.props;
        return (
            <CompareContext.Provider value={{
                itemsToCompare: itemsToCompare,
                setItemCompare: (articulo, callback) =>
                this.setItemCompare(articulo, callback),
                removeItem: (articulo, callback) =>
                this.removeItem(articulo, callback),
                clearCompareItems: this.clearCompareItems
            }}>
                {children}
            </CompareContext.Provider>
        );
    }
}

export default CompareProvider;



// WEBPACK FOOTER //
// ./src/components/CompareProvider/CompareProvider.js